/**
 * Display-only pricing label for public-facing UI (landing page, subscribe
 * button). ADVERTISED price, not a source of truth.
 *
 * NEVER use this for revenue calculations or reporting:
 *   - MRR must be computed from `User.subscriptionPriceCents` (per-user actual)
 *   - Per-event impact lives on `BillingEvent.amountCents` (from LMSQ payload)
 *
 * If we raise the advertised price, update this constant AND update the
 * LMSQ variant in the dashboard. Existing subscribers keep paying what LMSQ
 * charges them (stored in DB), which propagates on their next renewal.
 */
const DISPLAY_SUBSCRIPTION_PRICE_USD = 5.99;

// The $2.99 "Stream Suite" tier — the whole suite WITHOUT TTS / Voice Hold /
// per-viewer voices. Display-only, same caveats as above (the real charge is
// whatever the LMSQ suite variant bills; per-user actuals live on
// User.subscriptionPriceCents).
const DISPLAY_SUITE_PRICE_USD = 2.99;

module.exports = {
  DISPLAY_SUBSCRIPTION_PRICE_USD,
  DISPLAY_SUITE_PRICE_USD,
};
